import React from 'react';
import VerticalBox from "../../../../../../core/components/box/vertical";
import Typo from "../../../../../../core/components/typo";
import Button from "../../../../../../core/components/button";
import Avatar from "../../../../../../core/components/avatar";
import {getActiveOrganisation} from "../../../../../Auth/services/organisationService";
import {useAuthContext} from "../../../../../Auth/provider/AuthProvider";
import RenderIf from "../../../../../../core/components/render-if";
import {useNavigate} from "react-router-dom";

export default function OrganizationChangeCard(props) {
    const {organisationList} = useAuthContext();
    const activeOrganization = getActiveOrganisation();
    const navigate = useNavigate();
    return (
        <VerticalBox className="w-full shrink-0 p-4" icon="quote">
            <div className="flex w-full items-center gap-4">
                <Avatar
                    image={activeOrganization?.organization?.logoDetail?.url}
                    name={activeOrganization?.organization?.name ?? ""}
                    className="rounded-3xl"
                    size="sm"
                    avatarClassName="rounded-3xl"
                />

                <div className={'flex w-full justify-between'}>
                    <div className="flex flex-col">
                        <Typo as="h2" weight="bold" className="ui-clamp-1 w-full flex-1" type="primary">
                            {activeOrganization?.organization?.name}
                        </Typo>
                        <RenderIf cond={!!activeOrganization?.organization?.settingsPretty?.description}>
                            <Typo as="h4"  className="ui-clamp-1 w-full flex-1" type="primary">
                                {activeOrganization?.organization?.settingsPretty?.description}
                            </Typo>
                        </RenderIf>
                    </div>
                    {/*<RenderIf cond={organisationList?.length > 1}>*/}
                        <Button type="danger" containerClassName="self-end" scale="fit" size={'sm'} onClick={() => {
                            navigate('/app/gateway?click_form_profile')
                        }}>
                            تغییر کانون
                        </Button>
                    {/*</RenderIf>*/}
                </div>

            </div>
        </VerticalBox>
    );
}